<template>
  <div>
    <div class="QuotaManageCom" v-for="(item , index) of QuotaArr" :key="index" :id="'printQuotaManageComAll'+index" ref="printQuotaManageCom">
     <div class="Context">
        <div class="LOGO">
          <img src="@/assets/channel/GC.png" alt="">
        </div>
        <div class="rightTopText">
          {{ item.CusName }}
        </div>
        <div class="rightBottomText">
          Zylox-TonbridgeMedicalTechnologyCo.,Ltd
        </div>
          <div class="line">

        </div>
        <div class="TitleCenter">
          {{ item.Title }}
        </div>
        <div class="RevisionDate">
          <!-- <span style="text-decoration: underline;margin-left: 5px;margin-right: 5px;">1</span> -->
          修订时间：{{item.UpdateTime}}
        </div>
        <div class="company">
          {{ item.CusName }}（公章）:
        </div>
        <div class="Table">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th v-for="(itemheader , indexheader) of headerDataCompany" :key="indexheader" :style="[{width: `${ itemheader.columnwidth }px`}]">{{itemheader.label}}</th>
            </tr>
            <tr v-for="(items , indexs) of item.YearQuota" :key="indexs">
              <td>{{ items.Quota }}</td>
              <td>{{ items.YearQuota }}</td>
            </tr>
          </table>
        </div>
        <div class="JDCG">
          季度采购指标：
        </div>
        <div class="Table">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th v-for="(itemheaderJDCG , indexheaderJDCG) of headerDataJDCG" :key="indexheaderJDCG" :style="[{width: `${ itemheaderJDCG.columnwidth }px`}]">{{itemheaderJDCG.label}}</th>
            </tr>
            <tr v-for="(items , indexs) of item.QuarterQuota" :key="indexs">
              <td>{{ items.Quota }}</td>
              <td>{{ items.FirstQuarterQuota }}</td>
              <td>{{ items.SecondQuarterQuota }}</td>
              <td>{{ items.ThirdQuarterQuota }}</td>
              <td>{{ items.ForthQuarterQuota }}</td>
            </tr>
          </table>
        </div>
        <div class="monthQuota">
          月采购指标分配：
        </div>
        <div class="Table">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th v-for="(itemheaderMonth , indexheaderMonth) of headerDataMonth" :key="indexheaderMonth" :style="[{width: `${ itemheaderMonth.columnwidth }px`}]">{{itemheaderMonth.label}}</th>
            </tr>
            <tr v-for="(items , indexs) of item.MonthQuota" :key="indexs">
              <td>{{ items.Quota }}</td>
              <td>{{ items.JanQuota }}</td>
              <td>{{ items.FebQuota }}</td>
              <td>{{ items.MarQuota }}</td>
              <td>{{ items.AprQuota }}</td>
              <td>{{ items.MayQuota }}</td>
              <td>{{ items.JunQuota }}</td>
              <td>{{ items.JulQuota }}</td>
              <td>{{ items.AugQuota }}</td>
              <td>{{ items.SepQuota }}</td>
              <td>{{ items.OctQuota }}</td>
              <td>{{ items.NovQuota }}</td>
              <td>{{ items.DecQuota }}</td>
            </tr>
          </table>
        </div>
        <div class="QuotaManageFoot">
          <div class="Top">
            Building No. , 18 Keji Avenue, Wenyixi Road, Future Science & Technology City, Hangzhou, 311121, China
          </div>
          <div class="Centers">
            杭州市文一西路未来科技城科技大道18号1幢
          </div>
          <div class="Bottom">
            TEL：(+86) 571 8861 0082 FAX：(+86) 571 8861 0608 website:www.zyloxmedical.com
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script> 
import headerDataCompanyFrom from './headerData/headerDataCompany'
import headerDataJDCG from './headerData/headerDataJDCG'
import headerDataMonth from './headerData/headerDataMonth'
import Btn from '../../../../../../../components/common-btn.vue'
import printAll from '../../../../../../../common/Print'
export default {
  components: { Btn },
  props: {
    QuotaList: {
      type: Array
    }
  },
  data() {
    return {
      headerDataCompany: [],
      headerDataJDCG: [],
      headerDataMonth: [],
      QuotaArr: []

    }
  },
  created() { },
  mounted() {
    this.headerDataCompany = JSON.parse(JSON.stringify(headerDataCompanyFrom))
    this.headerDataJDCG = JSON.parse(JSON.stringify(headerDataJDCG))
    this.headerDataMonth = JSON.parse(JSON.stringify(headerDataMonth))
  },
  activated() { },
  updated() { },
  methods: {
    download() {
      this.$emit('download')
    },
    Print() {
      const styleSheet = `
   <style scoped lang='less'>
    table {
      border: 1px solid #eeeeee;
      border-collapse: collapse;
    }
    tr td,th{
  //   width: 240px;
      height: 32px;
      background: #f9f9f9;
      opacity: 1;
      text-align: center;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      border: 1px solid #eeeeee;
    }
    .Print {
      display: inline-block;
      margin-left: -10px;
    }
    .download {
      display: inline-block;
      margin-left: 950px;
      margin-top: 20px;
    }
    .printQuotaManageCom{
       width: 100%;
      height: 100%;
      position: relative;
      //  size: A4;
    }
    .QuotaManageCom {
      width: 100%;
      height: 100%;
      position: relative;
      }
      .Context {
        width: 1000px;
        // height: 760px;
        background: #ffffff;
        box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.10000000149011612);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: 0 auto;
        padding: 24px;
        position: relative;
      }
    .line{
      width: 100%;
      height: 1px;
      background-color: #333333;
      margin-top: 10px;
    }
   .LOGO img{
      width: 116.25px;
      height: 52px;
    }
    .rightTopText {
    font-size: 16px;
    font-weight: normal;
    color: #333333;
    float: right;
    margin-top: -55px;
    }

  .rightBottomText {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    float: right;
    margin-top: -20px;
  }

  .TitleCenter {
    font-size: 24px;
    font-weight: normal;
    color: #333333;
    position: relative;
    left: 313px;
    // margin-top: 40px;
    margin: 30px auto auto 40px;
  }

  .RevisionDate {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 20px;
  }

  .company {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }
  .JDCG {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }
  .monthQuota {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }
    .QuotaManageFoot {
      width: 752px;
      height: 60px;
      font-size: 10px;
      font-weight: normal;
      // border: 1px solid red;
      color: #333333;
      margin: 48px auto 0 auto;
      
    }
   .Top {
      text-align: center;
    }

    .Centers {
      text-align: center;
    }
    .Bottom {
      text-align: center;
    }
    .Table {
     margin-top: 8px;
    }
  </style>`;
      printAll('#printQuotaManageComAll', styleSheet, this.QuotaList , true)
    }
  },
  computed: {},
  watch: {
    QuotaList: {
      handler(NewVal , OldVal) {
        console.log(NewVal , OldVal);
        this.QuotaArr = NewVal
      }
    }
  },
}
</script>
<style scoped lang='less'>
.Print {
  display: inline-block;
  margin-left: -10px;
}
.download {
  display: inline-block;
  margin-left: 950px;
  margin-top: 20px;
}
.QuotaManageCom {
  width: 100%;
  height: 100%;
  position: relative;
  .Context {
    width: 1000px;
    // height: 760px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.10000000149011612);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin: 0 auto;
    padding: 24px;
    position: relative;
  }
  .LOGO {
    img {
      width: 116.25px;
      height: 52px;
    }
  }

  .rightTopText {
    font-size: 16px;
    font-weight: normal;
    color: #333333;
    float: right;
    margin-top: -55px;
  }

  .rightBottomText {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    float: right;
    margin-top: -20px;
  }

  .TitleCenter {
    font-size: 24px;
    font-weight: normal;
    color: #333333;
    position: relative;
    left: 313px;
    margin-top: 40px;
  }

  .RevisionDate {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 20px;
  }

  .company {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }
  .JDCG {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }
  .monthQuota {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }

  .QuotaManageFoot {
    width: 752px;
    height: 60px;
    font-size: 10px;
    font-weight: normal;
    // border: 1px solid red;
    color: #333333;
    margin: 48px auto 0 auto;

    .Top {
      text-align: center;
    }

    .Centers {
      text-align: center;
    }
    .Bottom {
      text-align: center;
    }
  }
}
.Table {
  margin-top: 8px;
}

table {
  border: 1px solid #eeeeee;
  border-collapse: collapse;
  tr {
    td,
    th {
      //   width: 240px;
      height: 32px;
      background: #f9f9f9;
      opacity: 1;
      text-align: center;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      border: 1px solid #eeeeee;
    }
  }
}
</style>